enum PAGE_TYPE {
  HOME = 'HOME',
  MINI_HOME= 'MINI_HOME',
  NORMAL = 'NORMAL',
  HIDE_CATEGORY = 'HIDE_CATEGORY',
  ONLY_LOGO = 'ONLY_LOGO',
  UNSUBSCRIBE = 'UNSUBSCRIBE',
}

export default PAGE_TYPE;
